import { useNavigate, useLocation } from 'react-router-dom';
import { useUiStore } from '@/stores';
import { Calendar, Megaphone, Users, LayoutDashboard, Settings } from 'lucide-react';
import { clsx } from 'clsx';

const NAV_ITEMS = [
  { path: '/', icon: Calendar, label: 'Citas', view: 'appointments' as const },
  { path: '/campaigns', icon: Megaphone, label: 'Campañas', view: 'campaigns' as const },
  { path: '/crm', icon: Users, label: 'CRM', view: 'crm' as const },
  { path: '/dashboard', icon: LayoutDashboard, label: 'Panel', view: 'dashboard' as const },
  { path: '/settings', icon: Settings, label: 'Ajustes', view: 'settings' as const },
];

export function BottomNav() {
  const navigate = useNavigate();
  const location = useLocation();
  const setCurrentView = useUiStore((s) => s.setCurrentView);

  return (
    <nav className="fixed bottom-0 left-0 right-0 z-40 bg-surface/90 backdrop-blur-md border-t border-border safe-area-pb">
      <div className="grid grid-cols-5 items-center py-2 px-1 max-w-lg mx-auto">
        {NAV_ITEMS.map((item) => {
          const isActive = location.pathname === item.path ||
            (item.path !== '/' && location.pathname.startsWith(item.path));
          return (
            <button
              key={item.path}
              onClick={() => { navigate(item.path); setCurrentView(item.view); }}
              className={clsx(
                'flex flex-col items-center justify-center gap-1 py-1 px-1 rounded-lg transition-colors w-full cursor-pointer',
                isActive ? 'text-brand-primary font-semibold' : 'text-text-muted hover:text-text-secondary'
              )}
            >
              <item.icon size={20} />
              <span className="text-[10px] font-medium tracking-tight leading-none text-center truncate w-full">
                {item.label}
              </span>
            </button>
          );
        })}
      </div>
    </nav>
  );
}
